(function () {
  var WOMEN_OFFSET = 1.5;

  function qs(root, sel) {
    return root.querySelector(sel);
  }
  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function normalizeSize(value) {
    var n = parseFloat(value);
    if (isNaN(n)) return String(value);
    return n % 1 === 0 ? String(n) : String(n);
  }

  function parsePairedLabel(value) {
    if (value == null || value === '') return null;
    var paired = String(value).match(/M\s*(\d+(?:\.\d+)?)\s*\/\s*W\s*(\d+(?:\.\d+)?)/i);
    if (!paired) return null;
    return { men: normalizeSize(paired[1]), women: normalizeSize(paired[2]) };
  }

  function parseSizePair(value) {
    var paired = parsePairedLabel(value);
    if (paired) return paired;
    if (value == null || value === '') return null;
    var text = String(value);
    var menOnly = text.match(/^\s*(?:M|Men'?s?)\s*[:\-]?\s*(\d+(?:\.\d+)?)\s*$/i);
    if (menOnly) {
      return { men: normalizeSize(menOnly[1]), women: menToWomen(menOnly[1]) };
    }
    var womenOnly = text.match(/^\s*(?:W|Women'?s?)\s*[:\-]?\s*(\d+(?:\.\d+)?)\s*$/i);
    if (womenOnly) {
      return { women: normalizeSize(womenOnly[1]), men: womenToMen(womenOnly[1]) };
    }
    var numbered = text.match(/^\s*(\d+(?:\.\d+)?)\s*$/);
    if (numbered) {
      return { men: normalizeSize(numbered[1]), women: menToWomen(numbered[1]) };
    }
    return null;
  }

  function variantPair(variant) {
    if (!variant) return null;
    var fields = [
      variant.sizeLabel,
      variant.option2,
      variant.option1,
      variant.option3,
      variant.title,
      variant.size
    ];
    var i;
    for (i = 0; i < fields.length; i++) {
      var paired = parsePairedLabel(fields[i]);
      if (paired) return paired;
    }
    if (variant.menSize || variant.womenSize) {
      var men = variant.menSize ? normalizeSize(variant.menSize) : null;
      var women = variant.womenSize ? normalizeSize(variant.womenSize) : null;
      if (men && !women) women = menToWomen(men);
      if (women && !men) men = womenToMen(women);
      if (men || women) return { men: men, women: women };
    }
    for (i = 0; i < fields.length; i++) {
      var parsed = parseSizePair(fields[i]);
      if (parsed) return parsed;
    }
    return null;
  }

  function sizeForRange(pair, range) {
    if (!pair) return null;
    return range === 'W' ? pair.women : pair.men;
  }

  function uniqueSizes(values) {
    var seen = {};
    var out = [];
    values.forEach(function (v) {
      if (!v || seen[v]) return;
      seen[v] = true;
      out.push(v);
    });
    return out.sort(function (a, b) {
      return parseFloat(a) - parseFloat(b);
    });
  }

  function menToWomen(size) {
    var n = parseFloat(size);
    if (isNaN(n)) return size;
    var w = n + WOMEN_OFFSET;
    return w % 1 === 0 ? String(w) : w.toFixed(1);
  }

  function womenToMen(size) {
    var n = parseFloat(size);
    if (isNaN(n)) return size;
    var m = n - WOMEN_OFFSET;
    return m % 1 === 0 ? String(m) : m.toFixed(1);
  }

  function init(root) {
    var dataEl = qs(root, '[data-shoes-2026-json]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var products = data.products || [];
    if (!products.length) return;

    var state = {
      productId: data.currentProductId || products[0].id,
      variantId: null,
      sizeValue: null,
      range: 'M'
    };

    function currentProduct() {
      for (var i = 0; i < products.length; i++) {
        if (String(products[i].id) === String(state.productId)) return products[i];
      }
      return products[0];
    }

    function productSizes(product, gender) {
      var values = [];
      (product.variants || []).forEach(function (variant) {
        var pair = variantPair(variant);
        var size = sizeForRange(pair, gender);
        if (size) values.push(size);
      });
      return uniqueSizes(values);
    }

    function findVariant(product, gender, size) {
      var variants = product.variants || [];
      var wanted = String(size);
      for (var i = 0; i < variants.length; i++) {
        var pair = variantPair(variants[i]);
        if (sizeForRange(pair, gender) === wanted) return variants[i];
      }
      return null;
    }

    function findVariantById(product, id) {
      if (!id) return null;
      var variants = product.variants || [];
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    function firstVariant(product) {
      var variants = product && product.variants;
      return variants && variants.length ? variants[0] : null;
    }

    function firstAvailableVariant(product) {
      var variants = (product && product.variants) || [];
      var i;
      for (i = 0; i < variants.length; i++) {
        if (variants[i].available !== false) return variants[i];
      }
      return firstVariant(product);
    }

    function selectableKeep(product, range, preferredVariant) {
      var keep = preferredVariant || findVariantById(product, state.variantId);
      var keepSize = sizeForRange(variantPair(keep), range);
      var onProduct = keepSize ? findVariant(product, range, keepSize) : null;
      if (onProduct && onProduct.available !== false) return onProduct;
      return firstAvailableVariant(product);
    }

    function applyGalleryImage(img, source, product) {
      if (!img || !source) return;
      img.src = source.src;
      img.alt = source.alt || product.title;
      img.setAttribute('data-photoswipe-src', source.zoomSrc || source.src);
      if (source.width) img.setAttribute('data-photoswipe-width', source.width);
      if (source.height) img.setAttribute('data-photoswipe-height', source.height);
    }

    function updateGallery(product) {
      var images = product.images || [];
      var hero = qs(root, '#heroImg');
      if (hero && images[0]) applyGalleryImage(hero, images[0], product);
      ['tileA', 'tileB', 'tileC', 'tileD'].forEach(function (id, index) {
        var img = document.getElementById(id);
        var tile = img ? img.closest('.gtile') : null;
        var source = images[index + 1];
        if (!img) return;
        if (source) {
          applyGalleryImage(img, source, product);
          if (tile) tile.style.display = '';
        } else if (tile) {
          tile.style.display = 'none';
        }
      });
      var tag = qs(root, '#heroTag');
      if (tag) tag.textContent = product.color;
      var stickyImg = qs(root, '.sticky-bar .info img');
      if (stickyImg && (product.swatchSrc || (images[0] && images[0].src))) {
        stickyImg.src = product.swatchSrc || images[0].src;
      }
    }

    function variantMessage(variant) {
      if (!variant) return '';
      var tag = variant.variantTag;
      if (Array.isArray(tag)) {
        tag = tag.filter(Boolean).join(', ');
      }
      if (tag) return String(tag).trim();
      if (variant.variantSale) return 'Final Sale';
      return '';
    }

    function updateProductBadge(hideSale) {
      var badge = qs(root, '#heroBadge');
      if (!badge) return;
      var product = currentProduct();
      var show = product.badge && !(hideSale && product.badge.type === 'sale');
      if (show) {
        badge.className = 'pbadge ' + product.badge.type;
        badge.textContent = product.badge.label;
        badge.style.display = 'inline-block';
      } else {
        badge.style.display = 'none';
      }
    }

    function isFinalSaleLabel(message) {
      return String(message || '').trim().toLowerCase() === 'final sale';
    }

    function updateVariantTag(variant) {
      var message = variantMessage(variant);
      var wrap = qs(root, '[data-variant-tags]');
      if (wrap) {
        wrap.textContent = message;
        wrap.classList.toggle('is-final-sale', isFinalSaleLabel(message));
        if (message) {
          wrap.removeAttribute('hidden');
          wrap.style.display = 'inline-block';
        } else {
          wrap.setAttribute('hidden', '');
          wrap.style.display = 'none';
        }
      }
      updateProductBadge(!!message);
      var formTag = qs(root, '[data-add-to-cart-variant-tags]');
      if (formTag) {
        if (message) {
          formTag.value = message;
          formTag.name = 'properties[Tag]';
        } else {
          formTag.value = '';
          formTag.removeAttribute('name');
        }
      }
    }

    function percentOff(price, compareAt) {
      var p = Number(price);
      var c = Number(compareAt);
      if (!p || !c || c <= p) return 0;
      return Math.floor(((c - p) / c) * 100);
    }

    function updatePrice(product, variant) {
      var source = variant || product;
      var price = source.priceFormatted || product.priceFormatted;
      var cents = source.price != null ? source.price : product.price;
      var compareAt = source.compareAt;
      var compareAtFormatted = source.compareAtFormatted;
      var priceEl = qs(root, '.price');
      if (priceEl) priceEl.textContent = price;
      var compareEl = qs(root, '.compare-at');
      var showCompare = compareAt && cents && Number(compareAt) > Number(cents) && compareAtFormatted;
      if (compareEl) {
        if (showCompare) {
          compareEl.textContent = compareAtFormatted;
          compareEl.hidden = false;
        } else {
          compareEl.textContent = '';
          compareEl.hidden = true;
        }
      }
      var pctEl = qs(root, '.pct-off');
      if (pctEl) {
        var off = showCompare ? percentOff(cents, compareAt) : 0;
        if (off > 0) {
          pctEl.textContent = '-' + off + '%';
          pctEl.hidden = false;
        } else {
          pctEl.textContent = '';
          pctEl.hidden = true;
        }
      }
      var atcLabel = 'Add to cart — ' + price;
      qsa(root, '.atc').forEach(function (btn) {
        if (!btn.dataset.idleLabel) btn.dataset.idleLabel = atcLabel;
        btn.dataset.idleLabel = atcLabel;
        if (btn.textContent.indexOf('Added') === -1) btn.textContent = atcLabel;
      });
    }

    function updateSticky() {
      var product = currentProduct();
      var meta = qs(root, '#stickyMeta');
      if (!meta) return;
      var sizeLabel = state.sizeValue
        ? 'Size ' + state.sizeValue + (state.range === 'M' ? ' M' : ' W')
        : 'Select size';
      meta.textContent = product.color + ' · ' + sizeLabel;
    }

    function applyVariant(product, variant, sizeValue) {
      state.variantId = variant ? variant.id : null;
      state.sizeValue = sizeValue || null;
      var idInput = qs(root, '[data-product-select], [name="id"]');
      if (variant && idInput) idInput.value = variant.id;
      updatePrice(product, variant);
      updateVariantTag(variant);
      updateSticky();
    }

    function renderSizes(range, preferredVariant) {
      state.range = range;
      var product = currentProduct();
      var grid = qs(root, '#sizeGrid');
      if (!grid) return;
      var keep = selectableKeep(product, range, preferredVariant);
      var keepSize = sizeForRange(variantPair(keep), range);
      var matched = false;
      grid.innerHTML = '';
      productSizes(product, range).forEach(function (sz) {
        var variant = findVariant(product, range, sz);
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'size';
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', 'false');
        button.setAttribute('aria-label', sz + (range === 'M' ? " Men's" : " Women's"));
        button.textContent = sz + (range === 'M' ? ' M' : ' W');
        if (!variant || variant.available === false) {
          button.classList.add('is-unavailable');
          button.disabled = true;
        }
        button.addEventListener('click', function () {
          qsa(grid, '.size').forEach(function (el) {
            el.setAttribute('aria-checked', 'false');
          });
          button.setAttribute('aria-checked', 'true');
          applyVariant(product, variant, sz);
        });
        grid.appendChild(button);
        if (
          !matched &&
          keepSize &&
          String(sz) === String(keepSize) &&
          variant &&
          variant.available !== false
        ) {
          button.setAttribute('aria-checked', 'true');
          applyVariant(product, variant, sz);
          matched = true;
        }
      });
      if (!matched) {
        state.variantId = null;
        state.sizeValue = null;
        updateVariantTag(firstAvailableVariant(product));
        updateSticky();
      }
    }

    function selectProduct(product, pushUrl) {
      var previous = findVariantById(currentProduct(), state.variantId);
      state.productId = product.id;
      if (!isLimitedOfferProduct(product)) recordRecentlyViewed(product.id);
      qsa(root, '.swatch').forEach(function (swatch) {
        swatch.setAttribute(
          'aria-checked',
          String(swatch.dataset.productId) === String(product.id) ? 'true' : 'false'
        );
      });
      var colorName = qs(root, '#colorName');
      if (colorName) colorName.textContent = '— ' + product.color;
      var title = qs(root, '.buy h1');
      if (title && product.styleTitle) title.textContent = product.styleTitle;
      updateGallery(product);
      updatePrice(product);
      renderSizes(state.range, previous);
      if (pushUrl && product.url && window.history && window.history.replaceState) {
        var next = product.url;
        if (window.location.search) next += window.location.search;
        window.history.replaceState({}, '', next);
      }
    }

    qsa(root, '.swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var id = swatch.dataset.productId;
        var product = products.filter(function (p) {
          return String(p.id) === String(id);
        })[0];
        if (product) selectProduct(product, true);
      });
    });

    var tabM = qs(root, '#tabM');
    var tabW = qs(root, '#tabW');
    if (tabM && tabW) {
      tabM.addEventListener('click', function () {
        tabM.setAttribute('aria-checked', 'true');
        tabW.setAttribute('aria-checked', 'false');
        renderSizes('M');
      });
      tabW.addEventListener('click', function () {
        tabW.setAttribute('aria-checked', 'true');
        tabM.setAttribute('aria-checked', 'false');
        renderSizes('W');
      });
    }

    function addToCart(btn) {
      if (!state.sizeValue) {
        var grid = qs(root, '#sizeGrid');
        if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var form = qs(root, 'form[action*="/cart/add"]') || qs(root, 'form.product-single__form');
      var idInput = qs(root, '[data-product-select], [name="id"]');
      if (!form || !idInput || !idInput.value) return;

      var idle = btn.dataset.idleLabel || btn.textContent;
      btn.textContent = 'Adding…';

      var body = 'id=' + encodeURIComponent(idInput.value) + '&quantity=1';
      var tagInput = qs(root, '[data-add-to-cart-variant-tags]');
      if (tagInput && tagInput.name && tagInput.value) {
        body += '&' + encodeURIComponent(tagInput.name) + '=' + encodeURIComponent(tagInput.value);
      }
      var endpoint = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';

      fetch(endpoint, {
        method: 'POST',
        body: body,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (res) {
          return res.json().then(function (json) {
            return { ok: res.ok, json: json };
          });
        })
        .then(function (result) {
          if (!result.ok || result.json.status === 422) {
            btn.textContent = idle;
            return;
          }
          btn.textContent = 'Added ✓';
          setTimeout(function () {
            btn.textContent = idle;
          }, 1600);
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: { product: result.json, addToCartBtn: btn }
            })
          );
        })
        .catch(function () {
          btn.textContent = idle;
        });
    }

    qsa(root, '.atc').forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        addToCart(btn);
      });
    });

    var buyPanel = qs(root, '.buy');
    var stickyBar = qs(root, '#stickyBar');
    if (buyPanel && stickyBar) {
      window.addEventListener(
        'scroll',
        function () {
          stickyBar.classList.toggle('show', buyPanel.getBoundingClientRect().bottom < 0);
        },
        { passive: true }
      );
    }

    var rdMore = qs(root, '#rdMore');
    var rdDesc = qs(root, '#rdDesc');
    if (rdMore && rdDesc) {
      rdMore.addEventListener('click', function () {
        var clamped = rdDesc.classList.toggle('clamped');
        rdMore.textContent = clamped ? 'View More' : 'View Less';
        rdMore.setAttribute('aria-expanded', String(!clamped));
      });
    }

    var tmOverlay = qs(root, '#tmOverlay');
    var hsaLink = qs(root, '#hsaLearnMore');
    bindDialog(tmOverlay, [hsaLink], [qs(root, '#tmClose'), qs(root, '#tmContinue')]);
    bindDialog(qs(root, '#sizeChartOverlay'), qsa(root, '[data-size-chart-open]'), [qs(root, '#sizeChartClose')]);

    qsa(root, '.acc > button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var acc = btn.parentElement;
        var open = acc.classList.toggle('open');
        btn.setAttribute('aria-expanded', String(open));
      });
    });

    var galGrid = qs(root, '.gallery-grid');
    var galDots = qs(root, '#galDots');
    if (galGrid && galDots) {
      galDots.innerHTML = '';
      qsa(galGrid, '.gtile').forEach(function (tile, i) {
        var dot = document.createElement('span');
        if (i === 0) dot.classList.add('on');
        galDots.appendChild(dot);
      });
      var dots = qsa(galDots, 'span');
      galGrid.addEventListener(
        'scroll',
        function () {
          var idx = Math.round(galGrid.scrollLeft / galGrid.clientWidth);
          dots.forEach(function (dot, i) {
            dot.classList.toggle('on', i === idx);
          });
        },
        { passive: true }
      );
    }

    var initial = currentProduct();
    selectProduct(initial, false);
    bindGalleryZoom(root);
  }

  function zoomItemFromImage(img) {
    if (!img) return null;
    return {
      msrc: img.currentSrc || img.src,
      src: img.getAttribute('data-photoswipe-src') || img.src,
      w: parseInt(img.getAttribute('data-photoswipe-width'), 10) || img.naturalWidth || 1600,
      h: parseInt(img.getAttribute('data-photoswipe-height'), 10) || img.naturalHeight || 1600,
      el: img
    };
  }

  function ensureZoomOverlay() {
    var el = document.querySelector('[data-shoes-2026-zoom]');
    if (el) return el;
    el = document.createElement('div');
    el.className = 'shoes-2026-zoom';
    el.setAttribute('data-shoes-2026-zoom', '');
    el.setAttribute('hidden', '');
    el.innerHTML =
      '<button type="button" class="shoes-2026-zoom-close" aria-label="Close zoom">✕</button>' +
      '<div class="shoes-2026-zoom-stage"><img alt=""></div>';
    document.body.appendChild(el);
    function close() {
      el.setAttribute('hidden', '');
      el.classList.remove('open');
    }
    el.querySelector('.shoes-2026-zoom-close').addEventListener('click', close);
    el.addEventListener('click', function (e) {
      if (e.target === el || e.target.classList.contains('shoes-2026-zoom-stage')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    var overlayImg = el.querySelector('img');
    overlayImg.addEventListener('click', close);
    return el;
  }

  function openFallbackZoom(item) {
    var overlay = ensureZoomOverlay();
    var overlayImg = overlay.querySelector('img');
    overlayImg.src = item.src;
    overlayImg.alt = (item.el && item.el.alt) || '';
    overlay.removeAttribute('hidden');
    overlay.classList.add('open');
  }

  function openGalleryZoom(tiles, index) {
    var items = tiles.map(function (tile) {
      return zoomItemFromImage(qs(tile, 'img'));
    }).filter(Boolean);
    if (!items.length) return;
    var start = Math.max(0, Math.min(index, items.length - 1));
    var pswpElement = document.querySelector('.pswp');
    if (window.PhotoSwipe && window.PhotoSwipeUI_Default && pswpElement) {
      var gallery = new window.PhotoSwipe(pswpElement, window.PhotoSwipeUI_Default, items, {
        allowPanToNext: false,
        captionEl: false,
        closeOnScroll: false,
        counterEl: false,
        history: false,
        index: start,
        pinchToClose: false,
        preloaderEl: false,
        scaleMode: 'zoom',
        shareEl: false,
        tapToToggleControls: false,
        getThumbBoundsFn: function (i) {
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var thumbnail = items[i] && items[i].el;
          if (!thumbnail) return { x: 0, y: 0, w: 0 };
          var rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      });
      gallery.init();
      return;
    }
    openFallbackZoom(items[start]);
  }

  function bindGalleryZoom(root) {
    var grid = qs(root, '.gallery-grid');
    if (!grid || grid.dataset.zoomBound) return;
    grid.dataset.zoomBound = '1';
    var pointerX = 0;
    var pointerY = 0;
    var moved = false;

    grid.addEventListener('pointerdown', function (e) {
      pointerX = e.clientX;
      pointerY = e.clientY;
      moved = false;
    });
    grid.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - pointerX) > 12 || Math.abs(e.clientY - pointerY) > 12) {
        moved = true;
      }
    });
    grid.addEventListener('click', function (e) {
      var tile = e.target.closest('.gtile-zoom');
      if (!tile || !grid.contains(tile)) return;
      if (moved) {
        e.preventDefault();
        return;
      }
      var tiles = qsa(grid, '.gtile-zoom').filter(function (el) {
        return el.style.display !== 'none';
      });
      var index = tiles.indexOf(tile);
      if (index < 0) return;
      e.preventDefault();
      openGalleryZoom(tiles, index);
    });
  }

  function bindDialog(overlay, openers, closers) {
    if (!overlay) return;
    function open(e) {
      if (e) e.preventDefault();
      overlay.classList.add('open');
    }
    function close() {
      overlay.classList.remove('open');
    }
    (openers || []).forEach(function (el) {
      if (el) el.addEventListener('click', open);
    });
    (closers || []).forEach(function (el) {
      if (el) el.addEventListener('click', close);
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  function starString(rating) {
    var n = parseInt(rating, 10) || 0;
    var out = '';
    var i;
    for (i = 1; i <= 5; i++) out += i <= n ? '★' : '☆';
    return out;
  }

  function reviewSourceLine(review) {
    var labels = {
      review_written_in_shop_app: 'Review written in Shop App',
      review_written_in_google: 'Review written in Google',
      review_written_in_etsy: 'Review written in Etsy'
    };
    var parts = [];
    (review.transparency_badges || []).forEach(function (badge) {
      if (labels[badge]) parts.push(labels[badge]);
    });
    (review.cf_answers || []).forEach(function (answer) {
      if (answer == null || answer === '') return;
      if (typeof answer === 'string') {
        parts.push(answer);
        return;
      }
      var question = answer.title || answer.question || answer.label || '';
      var value = answer.answer || answer.value || '';
      if (question && value) parts.push(question + ': ' + value);
      else if (value) parts.push(value);
    });
    return parts.join(' · ');
  }

  function featuredReviews(reviews, limit) {
    return (reviews || [])
      .filter(function (review) {
        return Number(review.rating) >= 4;
      })
      .sort(function (a, b) {
        return Number(b.rating) - Number(a.rating);
      })
      .slice(0, limit);
  }

  function bindReviewCards(scope) {
    qsa(scope, '[data-shoes-2026-review-cards]').forEach(function (grid) {
      var jsonEl = grid.parentElement && grid.parentElement.querySelector('[data-shoes-2026-reviews]');
      if (!jsonEl) return;
      var data;
      try {
        data = JSON.parse(jsonEl.textContent);
      } catch (err) {
        return;
      }
      var reviews = featuredReviews(data && data.reviews, parseInt(grid.getAttribute('data-card-count'), 10) || 3);
      if (!reviews.length) return;
      grid.innerHTML = '';
      reviews.forEach(function (review) {
        var title = review.body || '';
        if (!title && review.body_html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = review.body_html;
          title = tmp.textContent || tmp.innerText || '';
        }
        var body = reviewSourceLine(review);
        var who = review.reviewer_name || '';
        if (review.verified_buyer) who += (who ? ' · ' : '') + 'Verified';
        if (review.location) who += (who ? ' · ' : '') + review.location;
        var card = document.createElement('div');
        card.className = 'rcard';
        card.innerHTML =
          '<span class="stars"></span>' +
          (title ? '<h3></h3>' : '') +
          (body ? '<p></p>' : '') +
          (who ? '<p class="who"></p>' : '');
        card.querySelector('.stars').textContent = starString(review.rating);
        var h3 = card.querySelector('h3');
        if (h3) h3.textContent = title;
        var p = card.querySelector('p:not(.who)');
        if (p) p.textContent = body;
        var whoEl = card.querySelector('.who');
        if (whoEl) whoEl.textContent = who;
        grid.appendChild(card);
      });
      bindSlidebars(grid.parentElement || grid);
    });
  }

  function slidebarScrollers(scope) {
    var nodes = qsa(scope, '.carousel, .review-cards, .feat-cards').filter(function (el) {
      return el.closest('.shoes-2026-stack');
    });
    if (
      scope.matches &&
      scope.matches('.carousel, .review-cards, .feat-cards') &&
      scope.closest('.shoes-2026-stack') &&
      nodes.indexOf(scope) === -1
    ) {
      nodes.push(scope);
    }
    return nodes;
  }

  function updateSlidebar(scroller, bar) {
    if (!scroller || !bar) return;
    var thumb = bar.querySelector('.car-slidebar-thumb');
    if (!thumb) return;
    var overflow = scroller.scrollWidth - scroller.clientWidth;
    if (overflow <= 2) {
      bar.hidden = true;
      return;
    }
    bar.hidden = false;
    var thumbPct = Math.max((scroller.clientWidth / scroller.scrollWidth) * 100, 12);
    var leftPct = (scroller.scrollLeft / overflow) * (100 - thumbPct);
    thumb.style.width = thumbPct + '%';
    thumb.style.left = leftPct + '%';
  }

  function scrollFromSlidebarPointer(scroller, bar, clientX) {
    var track = bar.querySelector('.car-slidebar-track') || bar;
    var rect = track.getBoundingClientRect();
    var overflow = scroller.scrollWidth - scroller.clientWidth;
    if (overflow <= 0 || rect.width <= 0) return;
    var thumbRatio = Math.max(scroller.clientWidth / scroller.scrollWidth, 0.12);
    var thumbPx = rect.width * thumbRatio;
    var usable = Math.max(rect.width - thumbPx, 1);
    var x = clientX - rect.left - thumbPx / 2;
    var t = Math.max(0, Math.min(1, x / usable));
    scroller.scrollLeft = t * overflow;
  }

  function bindSlidebars(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var nodes = slidebarScrollers(scope);
    nodes.forEach(function (scroller) {
      var bar = scroller.nextElementSibling;
      if (!bar || !bar.classList.contains('car-slidebar')) {
        bar = document.createElement('div');
        bar.className = 'car-slidebar';
        bar.setAttribute('aria-hidden', 'true');
        bar.innerHTML = '<div class="car-slidebar-track"><span class="car-slidebar-thumb"></span></div>';
        scroller.insertAdjacentElement('afterend', bar);
      }

      updateSlidebar(scroller, bar);
      if (scroller.dataset.slidebarBound) return;
      scroller.dataset.slidebarBound = '1';

      scroller.addEventListener(
        'scroll',
        function () {
          updateSlidebar(scroller, bar);
        },
        { passive: true }
      );
      scroller.addEventListener(
        'load',
        function () {
          updateSlidebar(scroller, bar);
        },
        true
      );

      var dragging = false;
      bar.addEventListener('pointerdown', function (event) {
        if (event.button != null && event.button !== 0) return;
        dragging = true;
        bar.setPointerCapture(event.pointerId);
        scroller.style.scrollBehavior = 'auto';
        scrollFromSlidebarPointer(scroller, bar, event.clientX);
        event.preventDefault();
      });
      bar.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        scrollFromSlidebarPointer(scroller, bar, event.clientX);
      });
      function endDrag(event) {
        if (!dragging) return;
        dragging = false;
        scroller.style.scrollBehavior = '';
        if (event && bar.hasPointerCapture && bar.hasPointerCapture(event.pointerId)) {
          bar.releasePointerCapture(event.pointerId);
        }
      }
      bar.addEventListener('pointerup', endDrag);
      bar.addEventListener('pointercancel', endDrag);

      if (window.ResizeObserver) {
        var observer = new ResizeObserver(function () {
          updateSlidebar(scroller, bar);
        });
        observer.observe(scroller);
      }
    });
  }

  var slidebarResizeBound = false;
  function bindSlidebarResize() {
    if (slidebarResizeBound) return;
    slidebarResizeBound = true;
    window.addEventListener('resize', function () {
      qsa(document, '.car-slidebar').forEach(function (bar) {
        updateSlidebar(bar.previousElementSibling, bar);
      });
    });
  }

  function bindCarousels(scope) {
    qsa(scope, '.car-btn').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var carousel = document.getElementById(btn.dataset.car);
        if (!carousel) return;
        carousel.scrollBy({ left: (250 + 18) * 2 * parseInt(btn.dataset.dir, 10), behavior: 'smooth' });
      });
    });
  }

  function hideRelatedSection(el) {
    var sectionEl = el.closest('.shopify-section') || el;
    sectionEl.style.display = 'none';
  }

  function showRelatedSection(el) {
    var sectionEl = el.closest('.shopify-section') || el;
    sectionEl.style.display = '';
  }

  function readRecentlyViewedIds() {
    var ids = [];
    try {
      ids = JSON.parse(window.localStorage.getItem('recently-viewed') || '[]');
    } catch (e) {
      ids = [];
    }
    if ((!ids || !ids.length) && window.theme && Array.isArray(theme.recentlyViewedIds)) {
      ids = theme.recentlyViewedIds.slice();
    }
    if (!Array.isArray(ids)) ids = [];
    var seen = {};
    var out = [];
    ids.forEach(function (id) {
      var key = String(id);
      if (!key || seen[key]) return;
      seen[key] = true;
      out.push(key);
    });
    return out;
  }

  function isLimitedOfferProduct(product) {
    if (!product) return false;
    if (product.limitedOffer) return true;
    var title = String(product.title || '').toLowerCase();
    return title.indexOf('limited offer') !== -1;
  }

  function recordRecentlyViewed(id) {
    if (id == null || id === '') return;
    var key = String(id);
    var ids = readRecentlyViewedIds().filter(function (value) {
      return String(value) !== key;
    });
    ids.unshift(key);
    if (ids.length > 20) ids = ids.slice(0, 20);
    if (window.theme) theme.recentlyViewedIds = ids;
    try {
      window.localStorage.setItem('recently-viewed', JSON.stringify(ids));
    } catch (e) {}
  }

  function bindRecentlyViewed(scope) {
    qsa(scope, '[data-shoes-2026-recently-viewed]').forEach(function (el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      hideRelatedSection(el);

      var currentId = String(el.getAttribute('data-product-id') || '');
      var limit = parseInt(el.getAttribute('data-limit'), 10) || 8;
      var searchUrl = el.getAttribute('data-search-url');
      var carousel = qs(el, '.carousel');
      if (!searchUrl || !carousel) return;

      if (el.getAttribute('data-exclude-recent') !== 'true') {
        recordRecentlyViewed(currentId);
      }

      var fetchLimit = Math.max(limit * 2, 20);
      var parts = [];
      readRecentlyViewedIds().forEach(function (val) {
        if (String(val) === currentId) return;
        if (parts.length >= fetchLimit) return;
        parts.push('id:' + val);
      });

      if (!parts.length) return;

      var url =
        searchUrl +
        (searchUrl.indexOf('?') >= 0 ? '&' : '?') +
        'q=' +
        encodeURIComponent(parts.join(' OR '));

      fetch(url)
        .then(function (res) {
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cardsById = {};
          Array.prototype.slice.call(doc.querySelectorAll('.pcard')).forEach(function (card) {
            var id = String(card.getAttribute('data-product-id') || '');
            if (id && id !== currentId) cardsById[id] = card;
          });

          var ordered = [];
          parts.forEach(function (part) {
            var id = part.replace(/^id:/, '');
            if (cardsById[id]) ordered.push(cardsById[id]);
          });

          if (!ordered.length) return;
          ordered = ordered.slice(0, limit);

          carousel.innerHTML = '';
          ordered.forEach(function (card) {
            carousel.appendChild(card);
          });
          showRelatedSection(el);
          bindCarousels(el);
          bindSlidebars(el);
        })
        .catch(function () {});
    });
  }

  function bindRecommendations(scope) {
    qsa(scope, '[data-shoes-2026-recommendations][data-url]').forEach(function (el) {
      if (el.dataset.bound) return;
      el.dataset.bound = '1';
      var url = el.getAttribute('data-url');
      if (!url) return;

      function load() {
        fetch(url)
          .then(function (res) {
            return res.text();
          })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var incoming = doc.querySelector('[data-shoes-2026-recommendations]');
            if (!incoming || !incoming.querySelector('.pcard')) {
              hideRelatedSection(el);
              return;
            }
            el.replaceWith(incoming);
            bindCarousels(incoming);
            bindSlidebars(incoming);
          })
          .catch(function () {
            if (!el.querySelector('.pcard')) hideRelatedSection(el);
          });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            if (!entries[0] || !entries[0].isIntersecting) return;
            observer.disconnect();
            load();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        observer.observe(el);
      } else {
        load();
      }
    });
  }

  function boot() {
    if (window.__shoes2026Booted) return;
    window.__shoes2026Booted = true;
    bindCarousels(document);
    bindRecommendations(document);
    bindReviewCards(document);
    bindSlidebars(document);
    bindSlidebarResize();
    qsa(document, '.shoes-2026').forEach(init);
    bindRecentlyViewed(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target || document;
    bindCarousels(target);
    bindRecommendations(target);
    bindReviewCards(target);
    bindSlidebars(target);
    bindRecentlyViewed(target);
  });
})();
